import { ip_back } from "../config";

const PREFIX = "pingflo_tour";

function postTourEvent(event, payload) {
  try {
    const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
    if (!token) return;
    fetch(`${ip_back}api/usage/events`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event, ...payload }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* metering must not break the tour */
  }
}

export function trackTourEvent(name, payload = {}) {
  const event = `${PREFIX}_${name}`;
  try {
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent("smarttt:analytics", { detail: { event, ...payload } }));
    }
  } catch {
    /* ignore */
  }
  if (typeof console !== "undefined" && console.debug) {
    console.debug(`[Pingflo tour] ${event}`, payload);
  }
  postTourEvent(event, payload);
}
